import { LocationRelationship } from '../admin/location/shared/models/locationRelationship';
import { LocationSelectorStatus } from '../admin/location/shared/models/locationSelectorStatus';
import { SystemConfigValue } from '../admin/system-configuration/shared/models/system-config-value';
import { LocationSelectorInfo } from '../admin/user/shared/models/locationSelectorModel';
import { TenantModel } from '../core/models/tenant';
import { SyncResponseStatus } from '../shared/layout/app-layout/app-header/app-header.component';
import { ACClientConfiguration } from '../shared/models/acClientConfiguration';
import { UserInfoDto } from './../admin/user/shared/models/userinfo.dto';
import { UserSigninStatusModel } from './../lobby/shared/models/lobby-user-signin-status.model';

export interface CoreState {
    // holds the user signed in status for the lobby
    UserSignedInStatus: UserSigninStatusModel | null;
    // if the user assisting any lobby records this property would have the lobby entry id otherwise null
    CurrentAssistingLobbyEntryId: number | null;
    // This flag would trigger the popup windows to ask the user to signin when changed to true
    PromptSigningPopup: boolean;
    // This flag would trigger the popup which states the user cannot sign in
    UnableToSigningPopup: boolean;
    // This would hold the basic info about the currently logged in user
    // Only the information that are needed frequently and more commonly should be added here
    // This should be null only before the very first api call
    UnableToCheckInPopup: boolean;
    userInfo: UserInfoDto | null;

    LocationSelectorInfo: LocationSelectorInfo | null;

    LobbyLocationSelectorInfo: LocationSelectorInfo | null;

    ACLocationCode: string;
    // This property would hold url code for the currently logged in tenant
    // This property would have been combined with #UserInfo but this is retrieved from identity server separately
    // and this might not be required always hence its defined separately
    urlCode: string;
    // If the user permitted to change between tenants this property would hold the basic information about the
    // permitted tenants.
    availableTenants: TenantModel[];
    // This settings would hold the system configuration values
    systemConfigurations: SystemConfigValue[];
    // Holds available active branches that can be signed into
    availableActiveBranches: LocationRelationship[];
    locationSelectorStatus: LocationSelectorStatus;
    lobbySelectorChange: boolean;
    // AC Client Configuration
    acClientConfiguration: ACClientConfiguration | null;
    // Tenant logo image string
    tenantLogo: string;
    systemConfigLoaded: boolean;
    // Sync status
    syncStatus: SyncResponseStatus;
    clientCreationStatus: string;
}

export const initialState: CoreState = {
    UserSignedInStatus: null,
    CurrentAssistingLobbyEntryId: null,
    PromptSigningPopup: false,
    UnableToSigningPopup: false,
    UnableToCheckInPopup: false,
    userInfo: null,
    LocationSelectorInfo: null,
    LobbyLocationSelectorInfo: null,
    ACLocationCode: '',
    urlCode: '',
    availableTenants: [],
    systemConfigurations: [],
    availableActiveBranches: [],
    locationSelectorStatus: {
        errorMessage: '',
        isAssisting: false,
        isError: false
    },
    lobbySelectorChange: false,
    acClientConfiguration: null,
    tenantLogo: '',
    systemConfigLoaded: false,
    syncStatus: {} as SyncResponseStatus,
    clientCreationStatus: ''
};
